import type {
  OpeningOrderFeeUpdateRequestType,
  OpeningOrderFeeUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOpeningOrderFeeUpdate = (
  openingOrderFeeId: number,
  retailerId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: OpeningOrderFeeUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `opening-order-fee/${openingOrderFeeId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<OpeningOrderFeeUpdateResponseType>(response).data,
      ),
    onSettled: (response) => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.OpeningOrderFee],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OpeningOrderFee, retailerId],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.OpeningOrderFee, response?.id],
      });
    },
  });
};
